import React, { useState, useEffect } from 'react'

const Sidebar = ({ items, onSelectItem, selectedItemId }) => {
  const [activeId, setActiveId] = useState(selectedItemId ?? null); // State to track selected item

  useEffect(() => {
    setActiveId(selectedItemId);
  }, [selectedItemId]);

  const handleSelectItem = (item) => {
    setActiveId(item.id); // Update selected item
    onSelectItem(item); // Trigger onSelectItem callback
  };

  return (
    <div style={{ padding: "1rem", width: "100%" }}>
      {/* Loop through items to render main title, icon, and title */}
      {items.map((item) => (
        <div key={item.id} className="mb-2">
          {/* Main Title for each section */}
          {item.main && (
            <p className="text-sm text-text-tertiary font-normal mb-2">
              {item.main}
            </p>
          )}

          {/* Each item with icon and title */}
          <div
            className={`h-10 flex items-center justify-start gap-2 px-2 rounded-md cursor-pointer ${activeId === item.id ? 'bg-gray-100' : 'bg-background-primary'}`}
            style={{
              backgroundColor: activeId === item.id ? '#F9FAFB' : '', // Apply background color when selected
            }}
            onClick={() => handleSelectItem(item)}
          >
            <span>
              {activeId === item.id ? item.selected : item.icon}
            </span>
            <p className="m-0 text-base font-normal">{item.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
